export { default } from './BaseProps'
export { default as getDataSelector } from './helpers/getDataSelector'

export type { BaseProps } from './BaseProps.types'
